export default {
  headerText: 'Téléversez les variations de votre logo',
  subHeaderText: 'Ajoutez plusieurs versions du logo de votre entreprise à utiliser dans différents contextes et formats.',
  errors: {
    logoLoadError: 'Échec du chargement du logo',
    uploadFailed: 'Échec du téléversement du logo',
    deleteFailed: 'Échec de la suppression du logo',
    readingFileError: 'Échec de la lecture du fichier',
  },
  validationErrors: {
    maxSize: 'La taille du fichier ne doit pas dépasser 5 Mo.',
    fileType: 'Le type de fichier doit être JPEG, JPG ou PNG.',
    minDimensions: "L'image doit faire au moins {{min}}x{{min}} px.",
    maxDimensions: "L'image doit être inférieure à {{max}}x{{max}} px.",
    aspectRatio: "L'image doit être carrée (ratio 1:1).",
    unableToValidate: "Le fichier sélectionné n'a pas pu être validé.",
  },
  variants: {
    jobListing: {
      title: "Logo pour les offres d'emploi",
      description:
        "Ajoutez une version carrée de votre logo qui apparaîtra sur les offres d'emploi. Assurez-vous que votre image fait 700x700 pixels (entre 300x300 et 1000x1000 pixels), au format JPG, PNG ou JPEG, et ne dépasse pas 5 Mo.",
    },
    fullLogo: {
      title: 'Logo complet',
      description:
        'Ajoutez la version complète du logo de votre entreprise au format JPG, PNG ou JPEG, et ne dépassant pas 5 Mo.',
    },
  },
  uploadButton: {
    validating: 'Vérification...',
    uploading: 'Téléversement...',
    label: 'Téléverser',
    successMessage: 'Logo téléversé avec succès.',
  },
  deleteButton: {
    label: 'Supprimer',
    alertHeader: 'Supprimer {{logoTitle}}',
    alertBody: 'Cela supprimera votre {{logoTitle}} actuel. Vous pouvez en téléverser un nouveau à tout moment.',
    alertCancel: 'Annuler',
    alertConfirm: 'Supprimer',
    loadingText: 'Suppression...',
    successMessage: 'Logo supprimé avec succès.',
  },
};
